module.exports = __webpack_public_path__ + "static/portrait-f4623952b40e0cdf4bea93560e1db6c4.png";